import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetById,
  getCustomer,
} from "adminApi/CustomersApi/WakeUpCall";
import { validateForm } from "utils/validation";
import { WakeUpCallValidation } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditWakeUpCallForm from "./Componates/EditWakeUpCallForm";
import fields from "../json/WakeUpCalllFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";      

const EditRoomFacilityDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;
  const FeildName = "Wakeup Call"

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues,setErrors } = useFormChange(
    initialValues,
    WakeUpCallValidation
  );


  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues
  );

  const { data: facilityTypeOptions, loading } = useFetchAllData(getCustomer);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Update({ id, data: formValues });
    },
    (vals) => {
      const err = validateForm(vals, WakeUpCallValidation)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    `${FeildName} updated successfully`
  );
  return (
    <>
      {(loadingFetch || ( loadingSubmit || loading )) && <Spinner isSpinner={true} />}
      <EditWakeUpCallForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        SelectOptions={facilityTypeOptions}
        title={FeildName}
      />
    </>
  );
};

export default EditRoomFacilityDetail;
